import { render, staticRenderFns } from "./paidDetail.vue?vue&type=template&id=2d5c5480&scoped=true"
import script from "./paidDetail.vue?vue&type=script&lang=ts"
export * from "./paidDetail.vue?vue&type=script&lang=ts"
import style0 from "./paidDetail.vue?vue&type=style&index=0&id=2d5c5480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c5480",
  null
  
)

export default component.exports